const features = [
  {
    icon: 'ri-layout-grid-line',
    title: 'Complete Product Organization',
    description: 'Browse products through structured spreadsheets instead of endless searching across multiple platforms.',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Smart Product Comparison',
    description: 'Compare products, prices, categories, and features side by side before making purchasing decisions.',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Beginner Friendly Guides',
    description: 'Learn how Vigorbuy Spreadsheet works with clear step-by-step tutorials designed for every skill level.',
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Safety First Approach',
    description: 'Understand verification methods and adopt safer online shopping practices through our educational resources.',
  },
];

export default function FeatureCards() {
  return (
    <section className="py-14 md:py-20 bg-background-100" id="features">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
              Why Choose Vigorbuy Spreadsheet
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              Everything you need to discover and compare products efficiently, all in one organized system.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {features.map((feat) => (
              <div key={feat.title} className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 hover:border-accent-200 transition-all duration-200 group">
                <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                  <i className={`${feat.icon} text-accent-600 text-lg`}></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">
                  {feat.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {feat.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}